module.exports = __webpack_public_path__ + "static/media/public-location.78136600.svg";